module.exports = __webpack_public_path__ + "static/media/5.18.996c07a7.png";